import styled from '@emotion/styled'
import useConfig from '../../../config/state/use-config'

export default function StepFooter() {
  const config = useConfig()

  return <Root>{config.taxDeductibleMessage}</Root>
}

const Root = styled.footer`
  font-size: 12px;
  padding: 24px 0;
  line-height: 1.5;
  font-weight: 400;
  color: #6a6562;
  border-top: 1px solid #eaeaea;
`
